import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TypeEnum } from '../../../../models/template/type.enum';
import { TemplateEditorV2Component } from '../../base-template-editor-v2/template-editor-v2.component';

/**
 * Redesigned (v2) Email channel wrapper - same pattern as email-template.component.ts,
 * pointed at the new <app-template-editor-v2> instead of <app-template-editor>. Kept
 * fully parallel so the original /email-template route and component are untouched.
 */
@Component({
  selector: 'app-email-template-v2',
  imports: [TemplateEditorV2Component],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <app-template-editor-v2
      [templateType]="templateType"
      templateBasePath="/email-template-v2/"
      [enableDragDrop]="true"
      [enableBlockToolbar]="true"
      [showResponsysButton]="true"
      [showSaveAsEmpty]="true"
      [subscribeToMedia]="true"
      [defaultBlocks]="defaultBlocks" />
  `,
})
export class EmailTemplateV2Component {
  protected readonly templateType = TypeEnum.EMAIL;

  protected readonly defaultBlocks: { name: string; variables: Record<string, string> }[] = [
    { name: 'subject', variables: { Subject: '' } },
    { name: 'preheader', variables: { Preheader: '' } },
  ];
}
